<template>
  <q-breadcrumbs
    class="q-mb-sm q-ml-xs"
  >
    <template #separator>
      <q-icon
        size="1.5em"
        name="chevron_right"
        color="primary"
      />
    </template>

    <q-breadcrumbs-el
      v-for="breadcrumb in breadcrumbs"
      :key="breadcrumb.label"
      :label="breadcrumb.label"
      :icon="breadcrumb.icon"
      :to="breadcrumb.to"
    />
  </q-breadcrumbs>
</template>

<script>

const icons = {
  settings: 'settings',
  operations: 'engineering',
  developers: 'build',
  reports: 'insert_chart_outlined',
  support: 'help'
}

export default {
  name: 'Breadcrumbs',
  props: {
    name: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    breadcrumbs () {
      let route = ''
      const routeElements = this.$route.path.split('/')
      return _(routeElements).map((slug, index) => {
        if (slug === '') return null

        route += '/' + slug
        return {
          label: (this.name && index === routeElements.length - 1) ? this.name : _.startCase(slug),
          icon: icons[slug],
          to: route
        }
      }).compact().value()
    }
  }
}

</script>
